module.exports = __webpack_public_path__ + "593a3d53/img/share-action-icon.9c12578c.svg";